export default "__VITE_ASSET__bvZb9TWN__"